<template>
  <div class="px-4 pt-5 pb-3 sm:px-2">
    <label for="filter" class="sr-only">Search candidates</label>
    <div class="flex rounded-md shadow-sm">
      <div class="flex-grow focus-within:z-10">
        <input
          autocomplete="off"
          v-model="query"
          @keyup.enter="filter"
          id="filter"
          class="block w-full py-2 pl-1 pr-3 text-gray-900 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-400 rounded-none appearance-none rounded-l-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
          placeholder="Buscar ..."
        />
      </div>
      <button
        @click="filter"
        :disabled="query == ''"
        :class="[query == '' ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
        class="flex items-center px-3 py-2 -ml-px text-sm leading-5 text-gray-900 transition duration-150 ease-in-out bg-gray-100 border border-gray-400 rounded-r-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10"
      >
        <svg
          class="w-5 h-5 text-gray-400"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
            clip-rule="evenodd"
          />
        </svg>
        <span class="ml-2">Filtrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      query: ''
    }
  },

  methods: {
    filter() {
      this.$emit('data-filter', this.query)
    }
  }
}
</script>
